export default __webpack_public_path__ + "static/media/grain-gradient.89a78e9b.png";